<!--
 * @Author: zyy
 * @Date: 2022-11-21 15:25:08
 * @LastEditors: zyy
 * @LastEditTime: 2022-11-21 16:45:17
 * @Description: default
-->


<template>
    <div>
        <a-modal :title="modal.title" :confirm-loading="modal.loading" v-model="modal.show" @ok="confirmmodal"
            destroy-on-close centered :width="1000">
            <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules" ref="ruleForm">
                <a-form-model-item label="商品名称" v-if="form.shoprogoods">
                    <a-input v-model="form.shoprogoods.title" read-only />
                </a-form-model-item>
                <a-form-model-item label="订单编号">
                    <a-input v-model="form.order.order_sn" read-only />
                </a-form-model-item>

                <a-form-model-item label="用户">
                    <a-input v-model="form.user_id" read-only />
                </a-form-model-item>
                <a-form-model-item label="评价星级">
                    <a-input v-model="form.level" />
                </a-form-model-item>
                <a-form-model-item label="评价内容">
                    <a-input v-model="form.content" />
                </a-form-model-item>
                <a-form-model-item label="评价图片" >
                    <a-upload  list-type="picture-card" :action="$uploadUrl" class="app-avatar-uploader"
                        :before-upload="$beforeUpload" @change="handleChange" :file-list="form.images" multiple>
                        <a-icon type="plus" v-if="form.images.length < 9"></a-icon>
                    </a-upload>
                </a-form-model-item>
                <a-form-model-item label="显示状态">
                    <a-radio-group name="radioGroup" v-model="form.status">
                        <a-radio :value="'show'">显示</a-radio>
                        <a-radio :value="'hidden'">隐藏</a-radio>
                    </a-radio-group>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>

</template>
<script>
import { TJListMixin } from '@/mixins/list.js'
import CommentService from "@/io/goods/comment.js";

export default {
    props: ['submit'],
    name: 'commentlInfo',
    mixins: [TJListMixin],

    data() {
        return {
            form: {
                id:'',
                order_id:'',
                user_id:'',
                level:'',
                content:'',
                images:'',
                status:'',
                order:{}
            },

            modal: {
                loading: false,
                show: false,
                data: [],
                title: '编辑评价'
            },
            rules: {
                name: [
                    { required: true, message: '请输入模板名称' },
                ],
                type: [
                    { required: true, message: '请选择计价方式' },
                ],
            },

        }
    },
    methods: {
        handleChange(info) {
        let status = info.file.status;
        console.log(info,44)
        if (status) {
          this.form.images = info.fileList.map(val => {
            return {
              uid: val.uid,
              name: val.name,
              status: val.status,
              url: val.url || (val.response ? val.response.file : null)
            }
          });
        }
      },
        open(record) {
            if (record) {
                this.form = JSON.parse(JSON.stringify(record))
                this.form.images = this.form.images?this.form.images.map((val,index) => {
                    return {
                        url:val,
                        uid:index,
                        name:`12125${index}.jpg`
                    }
                }):[]
            }
            this.modal.show = true

        },



        confirmmodal() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    
                    console.log(this.form)
                        CommentService.edit({
                            ...this.form,
                            images:this.form.images.map(val => val.url).join(',')
                        }).then(res => {
                            this.modal.show = false
                            this.$emit('submit')
                        })
                }
            })




        }
    }

}
</script>
<style scoped lang="less">

</style>